// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioGroup_root__hl5VH"};